type StartChatErrorCode =
	| "InboxChannelIsInactive"
	| "NoValidContactFound"
	| "ClientHasChatInProgressWithAnotherAttendant"
	| "Default"

export const errorCodeToMessage: Record<StartChatErrorCode, string> = {
	InboxChannelIsInactive: "O canal do WhatsApp está desconectado.",
	NoValidContactFound: "Número de WhatsApp inválido.",
	ClientHasChatInProgressWithAnotherAttendant: "Esse cliente já está sendo atendido por outro atendente.",
	Default: "Algo deu errado e não conseguimos identificar. Entre em contato."
}
